module.exports = __webpack_public_path__ + "img/edible-logo.c808ae3e.png";